import { Component, OnDestroy } from '@angular/core';

import { OnInit } from '@angular/core';

import * as moment from 'moment';
import { FieldGeneratorService } from '../../services/field-generator.service';
import { FormDialogComponent } from '../form-dialog/form-dialog.component';
import { MatDialog } from '@angular/material';

import { LocationService } from '../../services/location.services';
import { LocationsDialogComponent } from '../locations-dialog/locations-dialog.component';
import { IncidentsDialogComponent } from '../incidents-dialog/incidents-dialog.component';
import { GlobalCfgService } from 'src/services/globalcfg.service';
import { EventBusService } from 'src/services/event-bus.service';
import { ActivatedRoute } from '@angular/router';
import { MessageService } from 'src/services/message.service';
import { AddLocationComponent } from './add-location/add-location.component';
import { AlertComponent } from '../alert/alert.component';

@Component({
  selector: 'rm-manage-location',
  templateUrl: './manage-location.component.html',
  styleUrls: ['./manage-location.component.css']
})
export class ManageLocationComponent implements OnInit, OnDestroy {

  data: any[] = [];
  columns: any[] = [
    { name: 'name', displayName: 'Name' },
    { name: 'address', displayName: 'Address', type: 'longstring' },
    { name: 'latitude', displayName: 'Latitude' },
    { name: 'longitude', displayName: 'Longitude' },
  ];
  gcp: any;
  subscriptions: any[] = [];
  role: any;

  constructor(
    private dialog: MatDialog,
    private fgService: FieldGeneratorService,
    private locationService: LocationService,
    private globalCfgService: GlobalCfgService,
    private ebService: EventBusService,
    private route: ActivatedRoute,
    private msgService: MessageService
  ) { }

  ngOnInit() {
    this.gcp = this.globalCfgService.getGcp();
    console.log("this.gcp", this.gcp);

    this.loadLocationData(this.gcp);

    this.subscriptions.push(this.ebService.particpantSelectionFetchedValue$.subscribe(
      (gcp) => {
        this.gcp = gcp;
        this.loadLocationData(this.gcp);
      }
    ));

    this.route.parent.url.subscribe(url => {
      //always the first part is role
      this.role = url.values().next().value.path;
    });
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  loadLocationData(gcp) {

    this.locationService.get(gcp).subscribe(
      (response: any[]) => {
        console.log("response", response);

        response.forEach(item => {

          item['actions'] = [
            // {name: 'edit', tip: 'Edit Location'},
            { name: 'my_location', tip: 'View on map' },
            { name: 'map', tip: 'View Distribution' }
          ];

          if (this.role == 'admin') {
            item['actions'].unshift({ name: 'edit', tip: 'Edit Location' });
          }
        })

        this.data = response;
      });
  }

  add() {
    this.gcp = this.globalCfgService.getGcp();
    if (!this.gcp) {
      const dialogRef = this.dialog.open(AlertComponent, {
        width: "450px",
        data: { 
          title: "Add Location",
          note: "Select an organisation and try again",
        },
      });

      return;
    }
    
    const dialogRef = this.dialog.open(AddLocationComponent, {
      width: '450px',
      data: { title: 'Add Location'}
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log("The dialog was closed", result);
      if (result == 'yes') {
        this.loadLocationData(this.gcp);
      }
    });
  }

  onActionClicked(event) {
    var rec = event.record;
    switch (event.actionName.name) {
      case 'edit':
        var fields = this.fgService.getFields(this.columns, event.record);
        const dialogRef = this.dialog.open(FormDialogComponent, {
          width: '450px',
          data: {
            title: 'Edit Location',
            // titleBgColor: 'primary',
            fields: fields,
            mode: 'edit',
            rec: rec
          }
        });
        dialogRef.afterClosed().subscribe(result => {
          console.log('The dialog was closed', result);
          if (result == 'yes') {
            this.loadLocationData(this.gcp);
          }
        });
        break;
      case 'my_location':
        this.dialog.open(LocationsDialogComponent, {
          width: '2400px',
          data: { gln: rec.gln, gcp: this.globalCfgService.getGcp() }
        });
        break;
      case 'map':
        this.dialog.open(IncidentsDialogComponent, {
          width: '2400px',
          data: { gln: rec.gln, gcp: this.globalCfgService.getGcp() }
        });
        break;
      default:
        console.log('Unhandled action: ', event.actionName);
    }
  }
}